import type { FilterPanelDefinition, FilterPanelKey, FilterTargetValue } from './types';

export const FILTER_PANEL_DEFINITIONS: FilterPanelDefinition[] = [
  { key: 'candidate_user', label: '求職者担当者', filterTarget: 'candidate' },
  { key: 'company_user', label: '企業担当者', filterTarget: 'company' },
  { key: 'company_tag', label: '企業タグ' },
  { key: 'job_tag', label: '求人タグ' },
  { key: 'candidate_tag', label: '求職者タグ' },
];

/** インサイトタブで表示するフィルターパネル（求職者担当者・求職者タグの2種類のみ） */
export const INSIGHT_FILTER_PANEL_DEFINITIONS: FilterPanelDefinition[] = [
  { key: 'candidate_user', label: '求職者担当者', filterTarget: 'candidate' },
  { key: 'candidate_tag', label: '求職者タグ' },
];

export const USER_FILTER_PANEL_BY_TARGET: Record<FilterTargetValue, FilterPanelKey> = {
  candidate: 'candidate_user',
  company: 'company_user',
};

export const createEmptyPanelIds = (): Record<FilterPanelKey, number[]> =>
  FILTER_PANEL_DEFINITIONS.reduce(
    (acc, { key }) => ({
      ...acc,
      [key]: [],
    }),
    {} as Record<FilterPanelKey, number[]>
  );
